module.exports = __webpack_public_path__ + "img/Reg-visa.ea3f60d4.svg";